<ng-container *ngIf="isAuthenticated">
  <!-- FAB canto inferior ESQUERDO. Fica "minimizado" (sem rótulo, menor) na
       tela atual quando o usuário oculta a ajuda por essa rota — ver
       AiHelpVisibilityService. Continua clicável para não virar beco sem
       saída (o toggle "Exibir ajuda nesta tela" vive no header do drawer). -->
  <button
    type="button"
    class="ai-help-fab"
    [class.is-open]="open"
    [class.is-minimized]="isHiddenOnScreen && !open"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    [attr.aria-label]="open ? 'Fechar a ajuda com IA' : 'Abrir a ajuda com IA'"
    [attr.data-hidden-screen]="isHiddenOnScreen"
    data-testid="ai-help-fab"
  >
    <span class="ai-help-fab__icon" aria-hidden="true">{{
      open ? "×" : "?"
    }}</span>
    <span class="ai-help-fab__label" *ngIf="!open && !isHiddenOnScreen"
      >Ajuda</span
    >
  </button>

  <!-- Drawer de chat -->
  <div
    class="ai-help-drawer"
    *ngIf="open"
    data-testid="ai-help-drawer"
    role="dialog"
    aria-label="Assistente de ajuda"
  >
    <header class="ai-help-drawer__header">
      <div class="ai-help-drawer__title">
        <span class="ai-help-drawer__spark" aria-hidden="true">✦</span>
        <div>
          <strong>Ajuda WAZIR</strong>
          <small>Tire dúvidas de como usar o sistema</small>
        </div>
      </div>
      <div class="ai-help-drawer__actions">
        <button
          type="button"
          class="ai-help-drawer__gear"
          (click)="toggleVisibilityForScreen()"
          [attr.aria-label]="
            isHiddenOnScreen
              ? 'Exibir ajuda nesta tela'
              : 'Ocultar ajuda nesta tela'
          "
          [attr.title]="
            isHiddenOnScreen
              ? 'Exibir ajuda nesta tela'
              : 'Ocultar ajuda nesta tela'
          "
          data-testid="ai-help-toggle-visibility"
        >
          <span aria-hidden="true">{{ isHiddenOnScreen ? "👁" : "⚙" }}</span>
        </button>
        <button
          type="button"
          class="ai-help-drawer__close"
          (click)="close()"
          aria-label="Fechar"
        >
          ×
        </button>
      </div>
    </header>

    <div
      class="ai-help-drawer__notice"
      *ngIf="isHiddenOnScreen"
      data-testid="ai-help-hidden-notice"
    >
      A ajuda está oculta nesta tela. Use
      <strong>Exibir ajuda nesta tela</strong> (⚙) para reativar aqui.
    </div>

    <!-- aria-live="polite": anuncia as respostas transmitidas (delta) para
         leitores de tela sem interromper o que o usuário estiver fazendo;
         aria-atomic="false" evita reler a conversa inteira a cada pedaço do
         streaming (achado de acessibilidade do CodeRabbit no PR #70). -->
    <div
      class="ai-help-drawer__body"
      #scrollBody
      data-testid="ai-help-body"
      aria-live="polite"
      aria-atomic="false"
      role="log"
    >
      <div class="ai-help-empty" *ngIf="messages.length === 0">
        <p>Olá! Posso te explicar como usar o WAZIR. Comece por um atalho:</p>
      </div>

      <div
        *ngFor="let message of messages"
        class="ai-help-msg"
        [class.ai-help-msg--user]="message.role === 'user'"
        [class.ai-help-msg--assistant]="message.role === 'assistant'"
        [attr.data-role]="message.role"
      >
        <div class="ai-help-msg__bubble">
          <ng-container *ngIf="message.role === 'assistant'; else plain">
            <div
              class="ai-help-msg__markdown"
              [innerHTML]="renderMarkdown(message.content)"
              data-testid="ai-help-assistant-text"
            ></div>
            <span
              class="ai-help-msg__cursor"
              *ngIf="message.streaming && !message.content"
              >…</span
            >

            <div
              class="ai-help-msg__citation"
              *ngIf="message.citation"
              data-testid="ai-help-citation"
            >
              <span aria-hidden="true">📄</span> Fonte:
              {{ message.citation.title }}
            </div>

            <button
              type="button"
              class="ai-help-cta"
              *ngIf="message.cta"
              (click)="openCta(message)"
              data-testid="ai-help-cta"
            >
              {{ message.cta.label }}
            </button>
          </ng-container>
          <ng-template #plain>{{ message.content }}</ng-template>
        </div>
      </div>
    </div>

    <div class="ai-help-drawer__shortcuts" *ngIf="messages.length === 0">
      <button
        type="button"
        class="ai-help-chip"
        *ngFor="let shortcut of shortcuts"
        (click)="askShortcut(shortcut)"
        [disabled]="sending"
        data-testid="ai-help-shortcut"
      >
        {{ shortcut.label }}
      </button>
    </div>

    <form class="ai-help-drawer__composer" (ngSubmit)="send()">
      <input
        type="text"
        [(ngModel)]="draft"
        name="aiHelpDraft"
        placeholder="Escreva sua dúvida…"
        aria-label="Escreva sua dúvida para o assistente de ajuda"
        autocomplete="off"
        [disabled]="sending"
        data-testid="ai-help-input"
      />
      <button
        type="submit"
        [disabled]="sending || !draft.trim()"
        aria-label="Enviar"
        data-testid="ai-help-send"
      >
        ➤
      </button>
    </form>
  </div>
</ng-container>
